module.exports = __webpack_public_path__ + "img/monitorStation.ce3d125b.png";